var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-overlay is-marginless"},[_c('div',{staticClass:"background-image"}),_c('div',{staticClass:"overlay-content-wrap"},[_c('div',{staticClass:"overlay-content"},[_c('Loader')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }